import styled from 'styled-components';

const Dot = styled.span`
  display: inline-block;
  width: ${props => props.$size * 0.7}px;
  height: ${props => props.$size * 0.7}px;
  border-radius: 50%;
  margin-left: 8px;
  margin-right: 2px;
  background: ${props => props.$dotColor};
`;

export const CheckerBox = styled.span`
  display: flex;
  gap: ${props => props.$gap ?? 6}px;
  font-size: ${props => props.$size ?? 12}px;
`;

export const IndicatorBox = styled.span`
  gap: ${props => props.$gap ?? 6}px;
  font-size: ${props => props.$size ?? 12}px;
`;

export const Checker = ({ ok, children }) => (
  <span>
    <span style={{ color: ok ?  '#22c55e' : '#ef4444' }}>
      {ok ? '✓' : '✗'}
    </span>
    {children}
  </span>
);

export const Indicator = ({ score, children, size = 12 }) => {
  const colors = [
    '#dc2626', // 0
    '#f97316', // 1
    '#eab308', // 2
    '#84cc16', // 3
    '#16a34a', // 4
  ];
  
  const color = colors[score];

  return(
    <IndicatorBox $size={size}>
      <Dot $size={size} $dotColor={color} />
      {children}
    </IndicatorBox>
  );
};